module.exports = __webpack_public_path__ + "docs/the-peg-80fbe5.md";